import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";

const data = [
  {
    key: "1",
    sector: "Corporate Law",
    subSectors: "Mergers, Acquisitions, Contract Disputes",
    incidentID: "Handles corporate legal matters",
  },
  {
    key: "2",
    sector: "Intellectual Property",
    subSectors: "Patents, Trademarks, Copyrights",
    incidentID: "Deals with IP-related issues",
  },
];
const LegalsectorTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };
  const columns = [
    {
      title: t("dashboard.legalSectors.sector"),
      dataIndex: "sector",
      key: "sector",
      render: (text) => <p className="text-darkGrey small font-poppins">{text}</p>,
    },
    {
      title: t("dashboard.legalSectors.subSectors"),
      dataIndex: "subSectors",
      key: "subSectors",
      render: (subSectors) => <p className="text-darkGrey small font-poppins">{subSectors}</p>,
    },
    {
      title: t("dashboard.legalSectors.incidentID"),
      dataIndex: "incidentID",
      key: "incidentID",
      render: (incidentID) => <p className="text-darkGrey small font-poppins">{incidentID}</p>,
    },
    {
      title: t("dashboard.legalSectors.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            onClick={() => {
              navigate("/legal-sectors/details");
            }}
          >
            {t("dashboard.legalSectors.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
    </>
  );
};

export default LegalsectorTable;
